var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1 19.66C19.69 18.76 19.91 18.3 20.36 17.29C17.04 16.03 16.51 11.3 19.79 9.48999C18.79 8.22999 17.38 7.5 16.05 7.5C15.09 7.5 14.43 7.75001 13.84 7.98001C13.34 8.17001 12.89 8.34 12.33 8.34C11.73 8.34 11.2 8.15001 10.64 7.95001C10.03 7.73001 9.39 7.5 8.59 7.5C7.1 7.5 5.51001 8.41 4.50001 9.97C3.08001 12.17 3.33001 16.29 5.62001 19.81C6.44001 21.07 7.54001 22.48 8.97001 22.5C9.57001 22.51 9.96 22.33 10.39 22.14C10.88 21.92 11.41 21.68 12.34 21.68C13.27 21.67 13.79 21.92 14.28 22.14C14.7 22.33 15.08 22.51 15.67 22.5C17.12 22.48 18.28 20.92 19.1 19.66Z",
    fill: "#346771"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.84 2.5C16 3.6 15.55 4.69001 14.96 5.45001C14.33 6.27001 13.23 6.91 12.17 6.87C11.98 5.81 12.47 4.71999 13.07 3.98999C13.74 3.18999 14.87 2.57 15.84 2.5Z",
    fill: "#346771"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.71e2ea620bc7132a1425bd8c0443c032.svg";
export { ForwardRef as ReactComponent };